import { ActionReducerMap } from '@ngrx/store';
import { UploadBexFileReducer } from '../reducers/upload-bex.reducer';
import { PackageVisualizerReducer } from './package-visualizer.reducer';


export const DEPLOYMENT_BEX_REDUCER: ActionReducerMap<IDeploymentState> = {
    uploadBexFile: UploadBexFileReducer,
    packageVisualizer: PackageVisualizerReducer
};
